import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getData } from 'features/dinamic/dinamicApi';

interface MenuState {
    status: string;
    error: string;
    modules: any[];
    show: boolean;
    active: number | null;
    unfoldable: boolean;
}

const initialState: MenuState = {
    status: 'idle',
    error: '',
    modules: [],
    show: true,
    active: null,
    unfoldable: false,
};

export const fetchMenu = createAsyncThunk('fetchMenu', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 19;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        toggleShow: (state, action) => {
            state.show = action.payload;
        },
        toggleUnfold: (state, action) => {
            state.unfoldable = action.payload;
        },
        updActive: (state, action) => {
            state.active = action.payload;
        },
        resetMenu: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchMenu.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenu.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.modules = data ? data : [];

            })
            .addCase(fetchMenu.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const selectStatus = (state: RootState) => state.menu.status;
export const selectActiveMenu = (state: RootState) => state.menu.active;
export const selectError = (state: RootState) => state.menu.error;
export const selectShow = (state: RootState) => state.menu.show;
export const selectUnfoldable = (state: RootState) => state.menu.unfoldable;
export const selectModules = (state: RootState) => state.menu.modules;
export const selectMenu = (state: RootState) => state.menu;

export const { toggleShow, toggleUnfold, resetMenu, updActive } = menuSlice.actions;

export default menuSlice.reducer;
